import { cn } from "@/lib/utils";
import { TriangleAlert } from "lucide-react";

type Props = {
  error?: string | null;
  className?: string;
  errors?: (string | null)[];
};

function Error({ error, className, errors }: Props) {
  if (!error) return null;

  return (
    <div
      className={cn(
        "text-[#FF3B30] bg-[#FF3B3033] w-full p-5 rounded-xl",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <TriangleAlert />
        <div>{error}</div>
      </div>

      <div className="flex flex-col gap-2 mt-4 ml-2 max-h-30 overflow-scroll text-sm break-words">
        {errors?.map((e) => <div>{e}</div>)}
      </div>
    </div>
  );
}

export default Error;
